'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDeviceDetect = require('react-device-detect');

var _DropDown = require('../DropDown/DropDown');

var _DropDown2 = _interopRequireDefault(_DropDown);

var _Label = require('../Label/Label');

var _Label2 = _interopRequireDefault(_Label);

var _SimpleMenu = require('../SimpleMenu/SimpleMenu');

var _SimpleMenu2 = _interopRequireDefault(_SimpleMenu);

var _Container = require('./components/Container.Select');

var _Container2 = _interopRequireDefault(_Container);

var _Icon = require('./components/Icon.Select');

var _Icon2 = _interopRequireDefault(_Icon);

var _Input = require('./components/Input.Select');

var _Input2 = _interopRequireDefault(_Input);

var _Value = require('./components/Value.Select');

var _Value2 = _interopRequireDefault(_Value);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components


var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false,
      focused: false,
      search: '',
      selected: null,
      highlight: null
    }, _this.focus = function () {
      _this.setState({
        focused: true,
        open: true
      });

      if (_this.props.onFocus) _this.props.onFocus();
    }, _this.blur = function (e) {
      var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.open;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
        return null;
      };

      _this.setState({
        focused: false,
        selected: null,
        highlight: null,
        open: open
      }, cb);

      if (_this.props.onBlur) _this.props.onBlur();
    }, _this.setFocus = function () {
      if (_reactDeviceDetect.isMobile || _this.props.notFilterable) return _this.focus();

      _this.dom.focus();
    }, _this.close = function (enter) {
      _this.blur(null, false, function () {
        if (enter && !!_this.dom) _this.dom.blur();
      });
    }, _this.onChange = function (value) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$enter = _ref2.enter,
          enter = _ref2$enter === undefined ? false : _ref2$enter;

      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;
      if (disabled) return;
      onChange(value);

      _this.setState({
        search: '',
        selected: null
      });

      if (!_this.multiple()) _this.close(enter);else _this.setFocus();
    }, _this.highlight = function () {
      var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var highlight = _this.state.highlight;

      var options = _this.getFilteredOptions();

      var flatOptions = _this.getFlatOptions(options).filter(function (opt) {
        return !opt.options || opt.options.length === 0;
      });

      if (!highlight) _this.setState({
        highlight: flatOptions.length > 0 ? flatOptions[0].value : null
      });
      var current = flatOptions.findIndex(function (_ref3) {
        var value = _ref3.value;
        return value === highlight;
      }) + (next ? 1 : -1);
      if (current < 0 || current >= flatOptions.length) return;

      _this.setState({
        highlight: flatOptions[current].value
      });
    }, _this.select = function () {
      var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var selected = _this.state.selected;
      var value = _this.props.value;
      if (!_this.multiple() || !selected && next) return;
      if (!selected) return _this.setState({
        selected: value.length > 0 ? value[value.length - 1] : null
      });
      var current = value.findIndex(function (val) {
        return val === selected;
      }) + (next ? 1 : -1);
      if (current < 0) return;
      if (current >= value.length) return _this.setState({
        selected: null
      });

      _this.setState({
        selected: value[current]
      });
    }, _this.onKeyDown = function (e) {
      if (e.key === 'Tab') return _this.close();
      var _this$state = _this.state,
          search = _this$state.search,
          selected = _this$state.selected,
          highlight = _this$state.highlight;

      switch (e.key) {
        case 'ArrowLeft':
          if (!_this.multiple() || search.length > 0) return;

          _this.select(false);

          e.preventDefault();
          break;

        case 'ArrowRight':
          if (!_this.multiple() || search.length > 0) return;

          _this.select(true);

          e.preventDefault();
          break;

        case 'ArrowUp':
          _this.highlight(false);

          e.preventDefault();
          break;

        case 'ArrowDown':
          _this.highlight(true);

          e.preventDefault();
          break;

        case 'Enter':
          if (!highlight) return;

          _this.onChange(highlight, {
            enter: true
          });

          e.preventDefault();
          break;

        case 'Backspace':
          if (!_this.multiple() || search.length > 0 || !selected) return;

          _this.onChange(selected);

          e.preventDefault();
          break;

        case 'Escape':
          if (!_this.multiple()) return;

          _this.setState({
            selected: null,
            highlight: null
          });

          e.preventDefault();
          break;

        default:
          break;
      }
    }, _this.onHighlight = function (highlight) {
      return _this.setState({
        highlight: highlight
      });
    }, _this.onUnhighlight = function (highlight) {
      return _this.setState({
        highlight: null
      });
    }, _this.onSearch = function (e) {
      if (_this.props.notFilterable) return;
      var search = e.target.value;

      _this.setState({
        search: search,
        selected: null
      });

      var options = _this.getFilteredOptions({
        search: search
      });

      var flatOptions = _this.getFlatOptions(options).filter(function (opt) {
        return !opt.options || opt.options.length === 0;
      });

      _this.setState({
        highlight: flatOptions.length > 0 ? flatOptions[0].value : null
      });
    }, _this.onSearchKeyDown = function (e) {}, _this.multiple = function () {
      return Array.isArray(_this.props.value);
    }, _this.placeholder = function () {
      return !_this.props.value || _this.multiple() && !_this.props.value.length ? _this.props.placeholder : null;
    }, _this.getOptions = function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$options = _ref4.options,
          options = _ref4$options === undefined ? _this.props.options : _ref4$options,
          _ref4$search = _ref4.search,
          search = _ref4$search === undefined ? _this.state.search : _ref4$search;

      return [].concat(_toConsumableArray(options)).map(function (opt) {
        var copy = _extends({}, opt);

        if (copy.options) copy.options = _this.getOptions({
          options: copy.options,
          search: search
        });
        return _extends({}, copy, {
          match: !search.length ? true : opt.label.toLowerCase().includes(search.toLowerCase())
        });
      });
    }, _this.getFilteredOptions = function () {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$options = _ref5.options,
          options = _ref5$options === undefined ? _this.props.options : _ref5$options,
          _ref5$search = _ref5.search,
          search = _ref5$search === undefined ? _this.state.search : _ref5$search;

      return _this.getOptions({
        options: options,
        search: search
      }).filter(_this.filterOption);
    }, _this.filterOption = function (option) {
      if (!option.options || !option.options.length || option.match) return option.match;
      var subOpts = [].concat(_toConsumableArray(option.options)).some(_this.filterOption);
      return subOpts;
    }, _this.getFlatOptions = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.options;
      return [].concat(_toConsumableArray(options)).reduce(function (flatten, option) {
        flatten = [].concat(_toConsumableArray(flatten), [_extends({}, option)]);
        if (option.options) flatten = [].concat(_toConsumableArray(flatten), _toConsumableArray(_this.getFlatOptions(option.options)));
        return flatten;
      }, []);
    }, _this.findOptionByValue = function (value) {
      return _this.getFlatOptions().find(function (opt) {
        return opt.value === value;
      });
    }, _this.getValues = function () {
      return (_this.multiple() ? _this.props.value : [_this.props.value]).filter(function (val) {
        return val !== null && val !== undefined && val.length;
      }).map(_this.findOptionByValue).filter(function (val) {
        return val !== null && val !== undefined;
      });
    }, _this.clickableContainer = function () {
      return _this.multiple() || !_this.props.notFilterable ? null : _this.setFocus;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Select, [{
    key: 'renderSelect',
    value: function renderSelect() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          options = _props.options,
          onChange = _props.onChange,
          placeholder = _props.placeholder,
          size = _props.size,
          disabled = _props.disabled,
          children = _props.children,
          error = _props.error,
          notFilterable = _props.notFilterable,
          props = _objectWithoutProperties(_props, ['value', 'options', 'onChange', 'placeholder', 'size', 'disabled', 'children', 'error', 'notFilterable']);

      var _state = this.state,
          focused = _state.focused,
          open = _state.open,
          search = _state.search,
          selected = _state.selected;
      var values = this.getValues();
      return _react2.default.createElement(_Container2.default, {
        focused: focused,
        size: size,
        disabled: disabled,
        error: error,
        onClick: this.clickableContainer()
      }, values.map(function (val) {
        return _react2.default.createElement(_Value2.default, {
          size: size,
          key: val.value,
          onClick: function onClick() {
            return _this2.onChange(val.value);
          },
          disabled: disabled,
          deletable: _this2.multiple(),
          selected: selected === val.value
        }, val.label);
      }), !_reactDeviceDetect.isMobile && !notFilterable && _react2.default.createElement(_Input2.default, _extends({
        type: 'text',
        placeholder: !values.length ? placeholder : null,
        value: search,
        onChange: this.onSearch,
        disabled: disabled,
        size: size
      }, props, {
        onFocus: this.focus,
        onBlur: this.blur,
        onKeyDown: this.onKeyDown,
        innerRef: function innerRef(dom) {
          _this2.dom = dom;
        },
        notFilterable: notFilterable
      })), _react2.default.createElement(_Icon2.default, {
        icon: open ? 'up' : 'down',
        onClick: this.setFocus
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          value = _props2.value,
          disabled = _props2.disabled,
          dropdownOptions = _props2.dropdownOptions;
      var _state2 = this.state,
          open = _state2.open,
          highlight = _state2.highlight;
      var options = this.getFilteredOptions();
      return _react2.default.createElement(_Label2.default, {
        label: children
      }, _react2.default.createElement(_DropDown2.default, _extends({
        visible: open && !disabled,
        trigger: this.renderSelect(),
        onClose: this.close,
        block: true
      }, dropdownOptions), _react2.default.createElement(_SimpleMenu2.default, {
        options: options,
        open: 'all',
        height: 300,
        selected: this.multiple() ? value : [value],
        onSelect: this.onChange,
        highlight: highlight,
        onHighlight: this.onHighlight,
        onUnhighlight: this.onUnhighlight
      })));
    }
  }]);

  return Select;
}(_react.Component);

Select.propTypes = {
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  options: _propTypes2.default.array,
  onChange: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['small', 'normal', 'large']),
  disabled: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  error: _propTypes2.default.bool,
  notFilterable: _propTypes2.default.bool,
  dropdownOptions: _propTypes2.default.object
};
Select.defaultProps = {
  disabled: false,
  children: null,
  size: 'normal',
  error: false,
  notFilterable: false,
  dropdownOptions: {}
};
exports.default = Select;